export const API_PATH_ApiCreateCompanyGet = '/services/auth-create-company';
